let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("c44jQ")).then(() => parcelRequire('5k5nc'));